import React, { useEffect, useState } from 'react'
import CloseImage from '../../assets/ic_close.png';
import { TextField } from '@material-ui/core';
import api from '../api';
import { format } from 'date-fns';

export default function DetailMonitoringOrder(props) {
    const [data, setData] = useState(null)

    useEffect(() => {
        getDataDetail()
    }, [])

    const getDataDetail = () => {
        api.create().getDetailMonitoringOrder(props.detail[8]).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setData(response.data.data)
                }
            }
        })
    }

    const handleSeparator = (string) => {
        let val = string.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return val
    }

    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Detail Monitoring Order</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                {data !== null && (
                    <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '20px 50px' }}>
                        <div className="column-1">
                            <TextField
                                label="Kode Transaksi"
                                value={data.transaction_code}
                                style={{ width: '100%' }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 18,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black'
                                    }
                                }}
                            />
                            <TextField
                                label="Spesialisasi"
                                value={data.speciality_name}
                                style={{ width: '100%', marginTop: 10 }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 18,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black'
                                    }
                                }}
                            />
                            <TextField
                                label="Waktu Layanan"
                                value={data.service_duration}
                                style={{ width: '100%', marginTop: 10 }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 18,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black'
                                    }
                                }}
                            />
                            <TextField
                                label="Status Transaksi"
                                value={data.status_name}
                                style={{ width: '100%', marginTop: 10 }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 18,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black'
                                    }
                                }}
                            />
                        </div>

                        <div className="column-2">
                            <TextField
                                label="Nama Pasien"
                                value={props.detail[1]}
                                style={{ width: '100%' }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 18,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black'
                                    }
                                }}
                            />
                            <TextField
                                label="Dokter"
                                value={data.doctor_name}
                                style={{ width: '100%', marginTop: 10 }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 18,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black'
                                    }
                                }}
                            />

                            <TextField
                                label="Tanggal & Jam Telemedicine"
                                value={`${format(new Date(data.telemedicine_date), 'dd MMM yyyy')} ${format(new Date(`2100-01-01 ${data.telemedicine_time}`), 'HH:mm')}`}
                                style={{ width: '100%', marginTop: 10 }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 18,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black'
                                    }
                                }}
                            />
                            <TextField
                                label="Biaya"
                                value={`Rp. ${handleSeparator(Number(data.cost))}`}
                                style={{ width: '100%', marginTop: 10 }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 18,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black'
                                    }
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
